import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  Card,
  Form,
  Button,
  Alert
} from "react-bootstrap";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    category: "",
    priority: "medium"
  });
  
  const [showAlert, setShowAlert] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    
    // Form is valid, show success alert
    setValidated(true);
    setShowAlert(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        message: "",
        category: "",
        priority: "medium"
      });
      setValidated(false);
      setShowAlert(false);
    }, 3000);
  };

  return (
    <>
      <div id="content-page" className="content-inner">
        <Container>
          <Row className="row-eq-height">
            <Col md="12">
              <Row className="mb-5">
                <Col md="12">
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">บริการ Tiktok</h4>
                    </div>
                  </div>
                </Col>
              </Row>
              
              {showAlert && (
                <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
                  เพิ่มวิวไลฟ์สดสำเร็จ!
                </Alert>
              )}
              
              <Row>
                <Col lg="6">
                  <Card>
                    <Card.Header>
                      <h4 className="card-title">ข้อมูลพื้นฐาน</h4>
                    </Card.Header>
                    <Card.Body>
                      <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Label>ชื่อวิวไลฟ์สด</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter your name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide your name.
                          </Form.Control.Feedback>
                        </Form.Group>
                        
                        <Form.Group className="mb-3" controlId="formEmail">
                          <Form.Label>อีเมล</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                          </Form.Text>
                        </Form.Group>
                        
                        <Form.Group className="mb-3" controlId="formCategory">
                          <Form.Label>หมวดหมู่</Form.Label>
                          <Form.Select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select a category</option>
                            <option value="support">Support</option>
                            <option value="sales">Sales</option>
                            <option value="billing">Billing</option>
                            <option value="technical">Technical</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select a category.
                          </Form.Control.Feedback>
                        </Form.Group>
                        
                        <Button variant="primary" type="submit" className="mt-2">
                          OK
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col lg="6">
                  <Card>
                    <Card.Header>
                      <h4 className="card-title">ข้อมูลเพิ่มเติม</h4>
                    </Card.Header>
                    <Card.Body>
                      <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formPriority">
                          <Form.Label>ความสำคัญ</Form.Label>
                          <div>
                            <Form.Check
                              inline
                              label="Low"
                              name="priority"
                              type="radio"
                              id="priority-low"
                              value="low"
                              checked={formData.priority === "low"}
                              onChange={handleChange}
                            />
                            <Form.Check
                              inline
                              label="Medium"
                              name="priority"
                              type="radio"
                              id="priority-medium"
                              value="medium"
                              checked={formData.priority === "medium"}
                              onChange={handleChange}
                            />
                            <Form.Check
                              inline
                              label="High"
                              name="priority"
                              type="radio"
                              id="priority-high"
                              value="high"
                              checked={formData.priority === "high"}
                              onChange={handleChange}
                            />
                          </div>
                        </Form.Group>
                        
                        <Form.Group className="mb-3" controlId="formMessage">
                          <Form.Label>รายละเอียด</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            placeholder="Enter your message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Please provide a message.
                          </Form.Control.Feedback>
                        </Form.Group>
                        
                        <Form.Group className="mb-3" controlId="formCheck">
                          <Form.Check
                            type="checkbox"
                            label="I agree to the terms and conditions"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            You must agree before submitting.
                          </Form.Control.Feedback>
                        </Form.Group>
                        
                        <Button variant="primary" type="submit" className="mt-2">
                          OK
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ContactUs;
